import { connect } from "react-redux";
import styled from "styled-components";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import EmailSent from "../../../images/email_sent.svg";
import { AuthTypes } from "../../../reducers/auth/types";
import { resendVerificationEmail } from "../../../reducers/auth/thunks";
import { Loading } from "../../common";

const Container = styled.div`
  margin: 10px auto 15px;
  max-width: 180px;
  max-height: 180px;
  img {
    width: 100%;
    height: 100%;
  }
`;

const NotReceived = styled.div`
  display: grid;
  gap: 5px;
  margin-bottom: 10px;

  & p {
    font-size: 12px;
    color: var(--white-100);
  }
  & strong {
    cursor: pointer;
    padding: 5px;
    color: var(--blue);
    font-size: 14px;

    :hover {
      color: var(--blue-300);
    }
  }
`;

function EmailVerificationSent({
  opened,
  loading,
  email,
  success,
  resendVerificationEmail,
  closeEmailSentModal,
}) {
  const handleClose = () => {
    closeEmailSentModal();
  };

  const handleResend = () => {
    resendVerificationEmail(email);
  };

  return (
    <>
      <Dialog
        open={opened}
        onClose={handleClose}
        aria-labelledby="email-verification-sent-title"
        aria-describedby="email-verification-sent-description"
        maxWidth="xs"
        style={{
          textAlign: "center",
        }}
      >
        <DialogTitle id="email-verification-sent-dialog-title">
          Verify your Email Address!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="email-verification-sent-dialog-description">
            We have sent you a verification email to your email address. Click
            and follow the link inside it.
          </DialogContentText>
          <Container>
            <img src={EmailSent} alt="email verification sent svg" />
          </Container>
          <NotReceived>
            {!success ? (
              <>
                <p>Didn't get the email?</p>
                <strong onClick={handleResend}>Resend</strong>
              </>
            ) : (
              <strong style={{ color: "#2ea043" }}>
                Success! We've resent a confirmation email. Check your inbox or
                spam box
              </strong>
            )}
          </NotReceived>
        </DialogContent>
      </Dialog>
      <Loading backdrop loading={loading} />
    </>
  );
}

const mapState = (state) => ({
  opened: state.auth.email_verification_sent,
  loading: state.auth.loading,
  success: state.auth.resent_success,
});

const mapDispatch = (dispatch) => ({
  closeEmailSentModal: () =>
    dispatch({ type: AuthTypes.CLOSE_EMAIL_VERIFICATION_SENT }),
  resendVerificationEmail: (email) => dispatch(resendVerificationEmail(email)),
});

export default connect(mapState, mapDispatch)(EmailVerificationSent);
